import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';
import { LeadForQueueSchema } from './shared/leadForQueue';

type Arguments = Record<string, never>;

export const schemaLoanRequestResolver_GetLeadsWithFailedAttribution = z.array(LeadForQueueSchema);

export type SchemaLoanRequestResolver_GetLeadsWithFailedAttribution = z.infer<
    typeof schemaLoanRequestResolver_GetLeadsWithFailedAttribution
>;

export type LoanRequestResolver_GetLeadsWithFailedAttribution = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetLeadsWithFailedAttribution
>;
